import React, {useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";
import {Form} from "react-bootstrap";
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import StatesSelect from "../util/StatesSelect";
import axios from "axios";
import MapIframeDrop from "../util/MapIframeDrop";
import TextUtil from "../util/TextUtil";
import {Input, Label} from "reactstrap";
import './assets/css/HospitalRegister.css';
import DropzoneImages from "../util/DropzoneImages";

const HospitalRegisterModal = ({show = false, onHide, id = null}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loadingCnpj, setLoadingCnpj] = useState(false);
    const [loadingCEP, setLoadingCEP] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [formData, setFormData] = useState({
        id: '',
        nu_cnpj_maintainer: '',
        social_reason: '',
        name: '',
        street_name: '',
        address_number: '',
        complement_name: '',
        neighborhood_name: '',
        zip_code: '',
        phone_number: '',
        fax_number: '',
        email_address: '',
        uf: '',
        id_city: '',
        city_name: '',
        latitude: '',
        longitude: ''
    });
    const [cities, setCities] = useState([]);

    const [imagesPreview, setImagesPreview] = useState([]);
    const [imagesFinal, setImagesFinal] = useState([]); // controla todas
    useEffect(() => {
        if (formData.images) {
            const imagensComuns = formData.images.filter(img => img.logo === 0);
            setImagesFinal(imagensComuns);
        }
    }, [formData.images]);


    useEffect(() => {
        if (show) {
            console.log(id);
            if (id) {
                fetchIdHospital(id);
            } else {
                // Resetar formulário se não houver ID
                setFormData({
                    id: '',
                    nu_cnpj_maintainer: '',
                    social_reason: '',
                    name: '',
                    street_name: '',
                    address_number: '',
                    complement_name: '',
                    neighborhood_name: '',
                    zip_code: '',
                    phone_number: '',
                    fax_number: '',
                    email_address: '',
                    uf: '',
                    id_city: '',
                    city_name: '',
                    latitude: '',
                    longitude: ''
                });
            }
        }
    }, [show, id]);


    useEffect(() => {
        const fetchCoords = async () => {
            const address = `${formData.street_name} ${formData.address_number}, ${formData.neighborhood_name}, ${formData.city_name} - ${formData.uf}, Brasil`;

            if (formData.street_name && formData.address_number && formData.city_name && formData.uf) {
                try {

                    const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "address/geocode", {address: address});
                    const {data} = ApiService.handleApiResponse(response);

                    setFormData(prev => ({
                        ...prev,
                        latitude: data.latitude,
                        longitude: data.longitude
                    }));

                } catch (error) {
                    console.error("Erro na API do Google:", error);
                }
            }
        };

        fetchCoords();
    }, [
        formData.street_name,
        formData.address_number,
        formData.neighborhood_name,
        formData.city_name,
        formData.uf
    ]);


    const handleUfChange = (selectedUf) => {
        const uf = selectedUf?.value || '';
        setFormData(prev => ({...prev, uf, id_city: '', city_name: ''}));
        if (!uf) return;

        ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: uf}, false)
            .then((res) => {
                const data = res.data;

                if (!data.errors) {
                    setCities(
                        data.map((city) => ({
                            value: city.id,
                            label: city.name,
                            latitude: city.latitude,
                            longitude: city.longitude,
                        }))
                    );
                }
            })
            .catch((error) => {
                ApiService.handleApiError(error);
            });
    };

    const handleSave = async () => {
        try {
            setIsSaving(true);
            const response = await ApiService.send(
                'post',
                `${process.env.REACT_APP_URL_API}hospitals/register`,
                formData,
                true
            );
            if (response?.code === 200) {
                Swal.fire('Sucesso', 'Hospital salvo com sucesso!', 'success');
                onHide(true);
            } else {
                throw new Error(response?.data?.message || 'Erro ao salvar hospital.');
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setIsSaving(false);
        }
    };


    const fetchIdHospital = async (id) => {
        try {
            setLoadingData(true);
            const response = await ApiService.send(
                'get',
                `${process.env.REACT_APP_URL_API}hospitals/onerecord/${id}`,
                null,
                true
            );

            const hospital = response.data;
            if (hospital) {
                setFormData({
                    id: hospital.id || '',
                    nu_cnpj_maintainer: hospital.nu_cnpj_maintainer || '',
                    social_reason: hospital.social_reason || '',
                    name: hospital.name || '',
                    street_name: hospital.street_name || '',
                    address_number: hospital.address_number || '',
                    complement_name: hospital.complement_name || '',
                    neighborhood_name: hospital.neighborhood_name || '',
                    zip_code: hospital.zip_code || '',
                    phone_number: hospital.phone_number || '',
                    fax_number: hospital.fax_number || '',
                    email_address: hospital.email_address || '',
                    uf: hospital.uf || '',
                    id_city: hospital.id_city || '',
                    city_name: hospital.city_name || '',
                    images: hospital.images || [],
                    latitude: hospital.latitude ? parseFloat(hospital.latitude) : 0,
                    longitude: hospital.longitude ? parseFloat(hospital.longitude) : 0,
                });

                await handleCitySelectionByUFAndId(hospital.uf, hospital.id_city);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingData(false);
        }
    };


    const handleCitySelectionByUFAndId = async (uf, idCity = '') => {
        try {

            setFormData(prev => ({
                ...prev,
                id_city: idCity
            }));

            const response = await ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf}, false);
            const cityData = response.data || [];

            const options = cityData.map(city => ({
                value: city.id,
                label: city.name,
                latitude: city.latitude,
                longitude: city.longitude,
                uf
            }));

            setCities(options);

            const matchedCity = options.find(city => city.value === idCity);

            setFormData(prev => ({
                ...prev,
                id_city: matchedCity?.value || '',
                city_name: matchedCity?.label || '',
                latitude: matchedCity?.latitude || '',
                longitude: matchedCity?.longitude || ''
            }));
        } catch (error) {
            console.error("Erro ao buscar cidades:", error);
        }
    };


    const handleChange = async (event) => {
        const {name, value} = event.target;

        setFormData(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));

        if (name === 'nu_cnpj_maintainer') {
            const cleanCnpj = value.replace(/\D/g, '');
            if (cleanCnpj.length === 14) {
                try {
                    setLoadingCnpj(true);
                    const responseCpf = await ApiService.send(
                        'get',
                        `${process.env.REACT_APP_URL_API}users/cnpj`,
                        {doc_number: cleanCnpj},
                        true
                    );

                    const data = responseCpf?.data;

                    if (data) {
                        const formattedCep = data.cep?.replace(/\D/g, '');
                        const ufOption = {value: data.uf, label: data.uf};
                        handleUfChange(ufOption);

                        setFormData(prev => ({
                            ...prev,
                            nu_cnpj_maintainer: data.cnpj,
                            social_reason: TextUtil.capitalizeFirst(data.nome),
                            name: TextUtil.capitalizeFirst(data.fantasia || data.nome),
                            street_name: TextUtil.capitalizeFirst(data.logradouro),
                            address_number: data.numero,
                            complement_name: TextUtil.capitalizeFirst(data.complemento),
                            neighborhood_name: TextUtil.capitalizeFirst(data.bairro),
                            zip_code: formattedCep,
                            phone_number: data.telefone,
                            email_address: data.email,
                            uf: data.uf,
                            city_name: TextUtil.capitalizeFirst(data.municipio)
                        }));


                        await handleCitySelectionByUFAndId(data.uf, data.id_city);
                    }
                } catch (err) {
                    console.error("Erro ao buscar CNPJ:", err);
                } finally {
                    setLoadingCnpj(false);
                }
            }
        }

        if (name === 'zip_code' && value.replace(/\D/g, '').length >= 8) {
            const cep = value.replace(/\D/g, '');

            try {
                setLoadingCEP(true);
                const res = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

                if (res?.data?.erro) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'CEP não encontrado',
                        text: 'Verifique se o CEP digitado está correto.',
                    });
                    return;
                }

                const {logradouro, bairro, localidade, uf} = res;
                const ufOption = {value: uf, label: uf};

                setFormData(prev => ({
                    ...prev,
                    uf,
                    city_name: '',
                    id_city: '',
                    street_name: TextUtil.capitalizeFirst(logradouro),
                    neighborhood_name: TextUtil.capitalizeFirst(bairro),
                    zip_code: value
                }));

                handleUfChange(ufOption);

                const responseCityId = await ApiService.send(
                    'post',
                    `${process.env.REACT_APP_URL_API}address/zip-code-city`,
                    {zip_code: value},
                    true
                );


                console.log(responseCityId);
                await handleCitySelectionByUFAndId(uf, responseCityId?.data.id_cidade);

            } catch (error) {
                console.error("Erro ao buscar CEP:", error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao buscar CEP',
                    text: 'Não foi possível buscar o endereço. Tente novamente mais tarde.',
                });
            } finally {
                setLoadingCEP(false);
            }
        }
    };


    const handleSubmitImage = async (event) => {
        setIsSaving(true);

        const imageFile = event.target.files[0];
        if (!imageFile) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Nenhuma imagem selecionada.',
            });
            setIsSaving(false);
            return;
        }

        const formDataUpload = new FormData();

        // Envia como array, igual ao handleUploadImages
        formDataUpload.append('images[0]', imageFile);
        formDataUpload.append('logo[0]', 1); // indica que é logo
        formDataUpload.append('hospital_id', formData.id);

        try {
            const response = await ApiService.sendArquivo(
                'post',
                `${process.env.REACT_APP_URL_API}hospitals/image`,
                formDataUpload
            );

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Imagem salva com sucesso!',
                });

                // atualiza a lista de imagens do hospital
                setFormData(prev => ({
                    ...prev,
                    images: response.data.images || []
                }));
            } else {
                throw new Error("Erro ao salvar imagem.");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setIsSaving(false);
        }
    };



    const handleRemoveImage = async (id) => {
        try {
            const response = await ApiService.send(
                'delete',
                `${process.env.REACT_APP_URL_API}hospitals/delete`,
                { id },
                true
            );

            if (response?.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Imagem removida com sucesso!',
                });
            } else {
                throw new Error(response?.message || 'Erro inesperado ao remover a imagem.');
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erro ao remover imagem',
                text: error.message || 'Ocorreu um erro. Tente novamente mais tarde.',
            });
        }
    };




    const handleUploadImages = async () => {
        if (!formData.id || imagesFinal.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Nenhuma imagem para enviar.',
            });
            return;
        }

        const formDataUpload = new FormData();

        imagesFinal.forEach((img, i) => {
            if (img.file instanceof File || img.file instanceof Blob) {
                formDataUpload.append(`images[${i}]`, img.file);
                formDataUpload.append(`logo[${i}]`, 0); // imagens comuns
            }
        });

        formDataUpload.append('hospital_id', formData.id);

        setIsSaving(true);

        try {
            const response = await ApiService.sendArquivo(
                'post',
                `${process.env.REACT_APP_URL_API}hospitals/image`,
                formDataUpload
            );

            if (response.code === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Imagens enviadas com sucesso!',
                });

                setFormData(prev => ({
                    ...prev,
                    images: response.data.images || []
                }));

                setImagesPreview([]); // limpa após envio
            } else {
                throw new Error("Erro ao salvar imagens.");
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="xl" backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Cadastrar Local</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="profile-menu mb-2">
                        <ul className="nav nav-tabs nav-tabs-solid">
                            <li className="nav-item">
                                <a
                                    className="nav-link active"
                                    data-bs-toggle="tab"
                                    href="#per_details_tab"
                                >
                                    Dados
                                </a>
                            </li>
                            {formData.id > 0 && (
                            <li className="nav-item">
                                <a
                                    className="nav-link"
                                    data-bs-toggle="tab"
                                    href="#per_image_tab"
                                >
                                    Imagens
                                </a>
                            </li>
                            )}
                        </ul>
                    </div>
                    <div className="tab-content profile-tab-cont">

                        <div className="tab-pane fade show active" id="per_details_tab">
                            <div className="row">
                                <div className="col-7 row">

                                    {formData.id > 0 && (
                                    <div className="col-3">
                                        <div className="col-2 m-3">
                                            <div className="hospital-img-wrapper-sm">
                                                <img
                                                    src={
                                                        formData?.images?.[0]?.file ||
                                                        process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"
                                                    }
                                                    className="hospital-img-preview-sm"
                                                    alt="Imagem do hospital"
                                                />
                                                <Label htmlFor="hospital-img-file-input"
                                                       className="hospital-img-edit-btn-sm">
                                                    <i className="ri-camera-fill"></i>
                                                    <Input
                                                        id="hospital-img-file-input"
                                                        type="file"
                                                        onChange={handleSubmitImage}
                                                        className="d-none"
                                                    />
                                                </Label>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                    <div className="col-9 ">
                                        <div className="form-group mt-4 d-flex align-items-end">
                                            <div className="w-100">
                                                <label>CNPJ</label>
                                                {loadingData ? (
                                                    <Skeleton height={38}/>
                                                ) : (
                                                    <InputMask
                                                        mask="99.999.999/9999-99"
                                                        className="form-control"
                                                        name="nu_cnpj_maintainer"
                                                        value={formData.nu_cnpj_maintainer}
                                                        onChange={handleChange}
                                                        placeholder={
                                                            !formData.id
                                                                ? 'Pesquise o CNPJ na tela de pesquisa'
                                                                : 'Digite o CNPJ'
                                                        }
                                                        disabled={!formData.id}
                                                    />
                                                )}
                                            </div>
                                            {loadingCnpj && (
                                                <div className="ms-2 mb-1">
                                            <span className="spinner-border spinner-border-sm text-primary"
                                                  role="status"/>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group col-12 ">
                                        <label>Nome</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="name"
                                                   value={formData.name}
                                                   onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-12">
                                        <label>Razão Social</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="social_reason"
                                                   value={formData.social_reason} onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="col-12 mt-1 d-flex align-items-center justify-content-center">
                                        <strong>Endereço</strong>
                                    </div>
                                    <div className="form-group col-6 position-relative">
                                        <label>CEP</label>
                                        <div className="d-flex align-items-center">
                                            {loadingData ? (
                                                <Skeleton height={38}/>
                                            ) : (

                                                <InputMask
                                                    mask="99999-999"
                                                    className="form-control"
                                                    name="zip_code"
                                                    value={formData.zip_code}
                                                    onChange={handleChange}
                                                />
                                            )}
                                            {loadingCEP && (
                                                <div className="ms-2">
                                            <span className="spinner-border spinner-border-sm text-primary"
                                                  role="status"/>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group col-8">
                                        <label>Logradouro</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="street_name"
                                                   value={formData.street_name} onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-4">
                                        <label>Número</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="address_number"
                                                   value={formData.address_number} onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-6">
                                        <label>Complemento</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="complement_name"
                                                   value={formData.complement_name} onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-6">
                                        <label>Bairro</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <input type="text" className="form-control" name="neighborhood_name"
                                                   value={formData.neighborhood_name} onChange={handleChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-6">
                                        <label>Estado</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <StatesSelect value={{value: formData.uf, label: formData.uf}}
                                                          onChange={handleUfChange}/>
                                        )}
                                    </div>
                                    <div className="form-group col-6">
                                        <label>Cidade</label>
                                        {loadingData ? (
                                            <Skeleton height={38}/>
                                        ) : (
                                            <Select
                                                value={cities.find(option => option.value === formData.id_city) || null}
                                                onChange={(option) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        id_city: option?.value || '',
                                                        city_name: option?.label || '',
                                                        latitude: option?.latitude || '',
                                                        longitude: option?.longitude || ''
                                                    }));
                                                }}
                                                options={cities}
                                                placeholder="Selecione a Cidade"
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                styles={{menuPortal: base => ({...base, zIndex: 9999})}}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="col-5">
                                    {loadingData ? (
                                        <Skeleton height={550}/>
                                    ) : (
                                        <MapIframeDrop
                                            latitude={formData.latitude}
                                            longitude={formData.longitude}
                                            draggable={true}
                                            onMarkerDrag={(lat, lng) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    latitude: lat,
                                                    longitude: lng
                                                }));
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                            <hr/>
                            <div className="mt-2">
                                <button type="button" className="btn btn-dark me-2" onClick={onHide}>
                                    <i className="fa fa-close"></i> Cancelar
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}
                                        disabled={isSaving}>
                                    {isSaving ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            {formData.id ? 'Atualizando...' : 'Salvando...'}
                                        </>
                                    ) : (
                                        <>
                                            <i className={`fa ${formData.id ? 'fa-save' : 'fa-plus'}`}></i>{' '}
                                            {formData.id ? 'Atualizar' : 'Cadastrar'}
                                        </>
                                    )}
                                </button>

                            </div>
                        </div>
                        <div className="tab-pane fade show" id="per_image_tab">
                            <DropzoneImages
                                images={imagesFinal}// mostra tudo
                                setImages={setImagesFinal} // atualiza só as novas
                                handleUploadImages={handleUploadImages}
                                handleRemoveImage={handleRemoveImage}
                            />
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>

            </Modal.Footer>
        </Modal>
    );
};

export default HospitalRegisterModal;